'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTilePromoCodeLabel = renderWithRef('StandardTilePromoCodeLabel', null, (e, a)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: [
            'swan-standard-tile-promo-code-label'
        ],
        props: e,
        children: e.children
    }));

export { StandardTilePromoCodeLabel };
